export default "__VITE_ASSET__CpmgI2XB__"